/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 * 
 */

import applySlashURL from "utils/applySlashURL";

const getAwsUrlFromLocation = () => {
  const currentUrl = new URL(window.location.origin);
  const currentUrlSubdomain = currentUrl.hostname.split(".").at(0);
  const currentUrlRest = currentUrl.hostname.split(".").slice(1).join(".");
  currentUrl.hostname = `${
    currentUrlSubdomain?.split("-")[0]
  }-foundation-api-user.${currentUrlRest}`;

  return currentUrl.toString();
};

const getAwsUrl = () => {
  // @ts-ignore
  const url = window._env_?.REACT_APP_API;
  if (url && url !== "" && url !== "undefined") {
    return url;
  }

  return getAwsUrlFromLocation();
};
const URLForHeroku = import.meta.env.VITE_API as string;

const url: string =
  applySlashURL(import.meta.env.VITE_API_SERVICE === "heroku" ? URLForHeroku :  getAwsUrl());

if (!url) {
  throw new Error("API is not defined");
}

export const urlMap = {
  v1: `${url}api/v1/`,
  v2: `${url}api/v2/`,
  v3: `${url}api/v3/`,
};

const mainURL: string = urlMap.v2;

export default mainURL;